import PlayIcon from '@mui/icons-material/PlayCircleOutline'
import { Tooltip } from '@mui/material'
import IconButton from '@mui/material/IconButton'
import { useLocation, useMatch, useNavigate } from 'react-router-dom'
import { drawerVar } from '../../../../../../providers/apollo/cache'

interface Props {
  color?: 'inherit' | 'primary' | 'secondary'
  albumId?: string
  username?: string
  onCompleted?: () => void
  disabled?: boolean
}

export default function AlbumPlay({ albumId, username = undefined, color = 'inherit', onCompleted = undefined, disabled = false }: Readonly<Props>) {
  const navigate = useNavigate()
  const location = useLocation()
  const isMyBucket = useMatch('/u/:userId')
  const isTrashView = useMatch('/u/:userId/trash')

  const handleClick = () => {
    drawerVar(null)
    if (isMyBucket) {
      navigate(`/u/${username}/slideshow`, { state: location.state })
    } else {
      navigate(`/u/${username}/a/${albumId}/slideshow`, { state: location.state })
    }
    if (onCompleted) {
      onCompleted()
    }
  }

  return (
    <IconButton
      color={color}
      aria-label="Slideshow"
      disabled={disabled || !!isTrashView}
      onClick={handleClick}
      id="slideshow-button"
      data-test="slideshow"
    >
      <Tooltip title="Start Slideshow" arrow>
        <PlayIcon />
      </Tooltip>
    </IconButton>
  )
}
